var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},_vm._l((_vm.totalTimes),function(item){return _c('div',{key:item,staticClass:"item",class:(item * _vm.comVal) < _vm.val?'active':''})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }